<template>
  <div v-editable="slide" class="relative size-full bg-gold">
    <div class="absolute inset-0">
      <AssetImage
        v-if="image"
        :blok="image"
        :lazy="index > 0"
        class="!mt-0 h-full"
        cover
      />
    </div>
    <Responsive
      :base-width="isMobile ? 0 : 1920"
      class="!absolute size-full sm:!relative"
      :ratio="ratio"
    >
      <div
        class="relative flex size-full select-none items-center justify-center overflow-hidden text-center"
        :class="[
          alignX === 'left' && 'sm:justify-start sm:text-left',
          alignX === 'center' && 'sm:justify-center sm:text-center',
          alignX === 'right' && 'sm:justify-end sm:text-right',
          alignY === 'top' && 'sm:items-start',
          alignY === 'middle' && 'sm:items-center',
          alignY === 'bottom' && 'sm:items-end',
        ]"
        @click="ctaClicked(slide, index)"
      >
        <div
          class="relative flex w-full flex-col gap-6 p-4 sm:w-1/2 sm:p-16"
          :class="{ 'sm:px-24': hasMultipleSlides }"
        >
          <StageKicker :data="slide" />
          <StageHeadline :data="slide" />
          <div v-if="hasLinkAndButton">
            <StageButton :data="slide" @click.stop="ctaClicked(slide, index)" />
          </div>
        </div>
      </div>
      <CMSLink
        v-if="hasLinkButNoButton"
        :to="
          hasLinkButNoButton && slide.link
            ? (toLocalePath(slide.link.cached_url || '') as string)
            : undefined
        "
        class="absolute inset-0 opacity-0"
        :aria-label="image?.altDescription"
        @click="ctaClicked(slide, index)"
      />
    </Responsive>
  </div>
</template>

<script setup lang="ts">
import type { SbStageSlide } from '~/cms/storyblok/types/storyblok.d.ts'

const props = defineProps<{
  slide: SbStageSlide
  index: number
  ratio?: string
  hasMultipleSlides: boolean
}>()

const { isMobile } = useDeviceType()
const alignX = computed(() => props.slide.align_x || 'center')
const alignY = computed(() => props.slide.align_y || 'middle')
const link = computed(() => props.slide.link?.cached_url)
const image = computed(() => props.slide.image?.[0])
const hasLinkAndButton = computed(() => props.slide.button_text && link.value)
const hasLinkButNoButton = computed(
  () => !props.slide.button_text && link.value,
)
const { ctaClicked } = inject('stage')! as any // emit does not work here

const { toLocalePath } = useRouteHelpers()

// Tailwind includes:
// text-gold-10
// text-gold-20
// text-gold-40
// text-gold-60
// text-gold-80
// text-gold
// text-lightGold-20
// text-lightGold-40
// text-lightGold-60
// text-lightGold-80
// text-lightGold
// text-black-10
// text-black-20
// text-black-40
// text-black-50
// text-black-60
// text-black-80
// text-black
// text-white-20
// text-white-40
// text-white-60
// text-white-80
// text-white
</script>
